import { c as _c } from "react/compiler-runtime";
import { useNumberFormatter } from "@opensea/i18n";
import { FlexColumn, Progress, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import { OPEN_EDITION_SUPPLY_THRESHOLD } from "@/components/collection/drops/constants";
import { useDropStore } from "../CollectionDropContext";
export function MintProgress() {
  const $ = _c(21);
  const [maxSupply, totalSupply] = useDropStore(useShallow(_temp));
  const format = useNumberFormatter();
  const t = useTranslations("MintProgress");
  const isOpenEdition = maxSupply >= OPEN_EDITION_SUPPLY_THRESHOLD;
  const totalSupplyText = format(totalSupply, {
    display: "full",
    custom: {
      maximumFractionDigits: 0
    }
  });
  let t0;
  if ($[0] !== format || $[1] !== isOpenEdition || $[2] !== maxSupply) {
    t0 = isOpenEdition ? "Open edition" : format(maxSupply, {
      display: "full",
      custom: {
        maximumFractionDigits: 0
      }
    });
    $[0] = format;
    $[1] = isOpenEdition;
    $[2] = maxSupply;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const maxSupplyText = t0;
  const showItemsMinted = totalSupply > 0;
  let t1;
  if ($[4] !== showItemsMinted || $[5] !== t) {
    t1 = showItemsMinted ? t("itemsMinted") : t("availableItems");
    $[4] = showItemsMinted;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = showItemsMinted ? `${totalSupplyText}${isOpenEdition ? "" : ` / ${maxSupplyText}`}` : maxSupplyText;
  let t4;
  if ($[9] !== t3) {
    t4 = <TextBody>{t3}</TextBody>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <SpaceBetween>{t2}{t4}</SpaceBetween>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isOpenEdition || $[15] !== maxSupply || $[16] !== totalSupply) {
    t6 = isOpenEdition ? null : <Progress className="h-3" value={totalSupply / maxSupply * 100} />;
    $[14] = isOpenEdition;
    $[15] = maxSupply;
    $[16] = totalSupply;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <FlexColumn className="gap-3">{t5}{t6}</FlexColumn>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp(state) {
  return [state.maxSupply ?? 0, state.totalSupply ?? 0, state.totalSupply];
}